import "react-multi-carousel/lib/styles.css";
import './css/Carousel.css';
import { useMediaQuery } from 'react-responsive';

const videoHeight = 450;
const baseVideoURL = "https://www.youtube.com/embed/";

function HomeCarouselItem({videoUrl, description}){
    const isMobile = useMediaQuery({ query: `(max-width: 960px)` });
    const finalVideoURL = baseVideoURL+videoUrl;
    // console.log(videoUrl);
    return (
        <div className={isMobile ? "carousel-item-mobile" : "carousel-item"}>
            <iframe
                src={finalVideoURL}
                frameBorder='0'
                allow='autoplay; encrypted-media'
                allowFullScreen
                title='video'
                height={videoHeight}
                width='100%'
            />
            <br /><br />
            <div className="carousel-desc">
                <p>
                {description}
                </p>
            </div>
        </div>
    )
}

export default HomeCarouselItem;
